import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const BoxCard = styled(Box)(({ theme }) => ({
    position:'relative',
    display: 'flex',
    width: '140px',
    height: '140px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'var(--main-system-4-px, 4px)',
    background: 'var(--background-light-disabled, #E5E5E7)',
}))
export const BoxTitle = styled(Box)(({ theme }) => ({
    marginTop: '4px',
    width: '140px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}))